<template>
  <div class="warp warp_index">
    <Head></Head>
    <!-- banner区域 -->
    <div class="banner" v-if="banner.length > 0">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in banner" :key="index"
            :style="'background: url('+item.img1+') center no-repeat; background-size: cover;'">
            <div class="item" @click="gotoPage(item)">

              <div class="text_box">
                <div class="t1">
                  {{item.tags}}
                </div>
                <div class="t2">
                  {{item.title}}
                </div>
                <div class="t3">
                  <span v-html="item.introduce"> </span>

                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

      <!-- 切换按钮 -->

      <div class="index_prev" @click="clickPrev">
        <img src="/static/img/p9.png" />
      </div>
      <div class="index_next" @click="clickNext">
        <img src="/static/img/p10.png" />
      </div>

    </div>

    <!-- 版权 -->
    <div class="copy_bottom" v-if="copydata">
      <a href="http://beian.miit.gov.cn/">{{copydata[4].varvalue}}</a>

    </div>

  </div>
</template>

<script>
  import {
    postIndexAPI,
    postconfigAPI
  } from '../../../api/api.js'
  import Head from '@/components/Head.vue'
  import 'swiper/swiper-bundle.min.css'
  import Swiper from 'swiper'; //引入swiper
  var mySwiper;
  export default {
    components: {
      Head
    },
    // {
    //   id: 0,
    //   pic: '/static/img/index_1.png',
    //   title: 'Company Introducton',
    //   dect: '公司介绍',
    //   conts: 'Full media marketing  service  provider'
    // }, {
    //   id: 1,
    //   pic: '/static/img/index_2.png',
    //   title: 'Service Scope',
    //   dect: '服务内容',
    //   conts: 'Full media marketing  service  provider'
    // }, {
    //   id: 2,
    //   pic: '/static/img/index_3.png',
    //   title: 'Service Case',
    //   dect: '服务案例',
    //   conts: 'Full media marketing  service  provider'
    // }, {
    //   id: 3,
    //   pic: '/static/img/index_4.png',
    //   title: 'Our Clients',
    //   dect: '服务客户',
    //   conts: 'Full media marketing  service  provider'
    // }, {
    //   id: 4,
    //   pic: '/static/img/index_5.png',
    //   title: 'Company Honor',
    //   dect: '企业荣誉',
    //   conts: 'Full media marketing  service  provider'
    // }, {
    //   id: 5,
    //   pic: '/static/img/index_6.png',
    //   title: 'Company History',
    //   dect: '企业历程',
    //   conts: 'Full media marketing  service  provider'
    // }, {
    //   id: 6,
    //   pic: '/static/img/index_7.png',
    //   title: 'Management Team',
    //   dect: '公司管理层',
    //   conts: 'Full media marketing  service  provider'
    // }
    data() {
      return {
        banner: [],
        soild_int: 1,
        copydata: null,

      }
    },
    methods: {
      clickPrev() {
        console.log(mySwiper);
        var that = this;
        if (that.soild_int == 2) {
          mySwiper.slideTo(0);
          that.soild_int = 1;
          return false;
        }
        if (that.soild_int == 3) {
          mySwiper.slideTo(3);
          that.soild_int = 2;
          return false;
        }

      },
      clickNext() {
        var that = this;
        console.log(mySwiper);
        if (that.soild_int == 1) {
          that.soild_int = 2;
          mySwiper.slideTo(3);
          return false
        }
        if (that.soild_int == 2) {
          that.soild_int = 3;
          mySwiper.slideTo(6);
          return false
        }
      },
      //kongzhid
      kongzhign(type, row) {
        console.log(mySwiper.translate);
        console.log(mySwiper.width);

        if (type == 1) {
          console.log('向上滚动');
          if (mySwiper.translate == 0) {
            return false
          }

          mySwiper.setTranslate(mySwiper.translate + 100)
        } else if (type == 2) {
          console.log('向下滚动');
          if (mySwiper.translate < Number(-mySwiper.width) + (Number(-mySwiper.width) / 3.4)) {
            return false
          }

          mySwiper.setTranslate(mySwiper.translate - 100)
        }
        console.log(row);
        mySwiper.setTransition(500);
      },

      handleScroll(e) {
        var that = this;

        var e = e || window.event;
        if (e.wheelDelta) {
          if (e.wheelDelta > 0) { //当鼠标滚轮向上滚动时
            that.kongzhign(1, e)
          }
          if (e.wheelDelta < 0) { //当鼠标滚轮向下滚动时
            that.kongzhign(2, e)
          }
        } else if (e.detail) {
          if (e.detail < 0) { //当鼠标滚轮向上滚动时
            that.kongzhign(1, e)
          }
          if (e.detail > 0) { //当鼠标滚轮向下滚动时
            that.kongzhign(2, e)
          }
        }
        //往右侧
        // if(m.deltaY == 100){
        //   if(mySwiper.translate < Number(-mySwiper.width)+(Number(-mySwiper.width)/3.6)){
        //     return false
        //   }
        //    mySwiper.setTranslate(mySwiper.translate - 100)
        // }
        // else if(m.deltaY == 0){

        //    mySwiper.setTranslate(mySwiper.translate + 100)
        // }


        // 如果已经达到最右侧-再次滚动滚动条就不起作用

        // mySwiper.translate

        //mySwiper.scrollbar.updateSize();

        // if (m.deltaY > 0) {
        //   mySwiper.slideNext();

        // } else if (m.deltaY < 0) {

        //   mySwiper.slidePrev();

        // }
      },
      gotoPage(row) {
        var that = this;
        console.log(row);
        if (row.title == '服务客户') {
          console.log('跳转到服务页面');
          this.$router.push({
            path: 'servingcustomers'
          })
        }

        if (row.id == 74) {
          console.log('跳转到介绍页面');
          this.$router.push({
            path: 'enterprise'
          })
        }

        if (row.id == 76) {
          console.log('跳转服务案例');
          this.$router.push({
            path: 'cases'
          })
        }

        if (row.id == 75) {
          console.log('跳转服务内容');
          this.$router.push({
            path: 'service'
          })
        }

        if (row.id == 78) {
          console.log('跳转企业荣誉');
          this.$router.push({
            path: 'honor'
          })
        }

        if (row.id == 79) {
          console.log('跳转企业招聘');
          this.$router.push({
            path: 'recruit'
          })
        }

        if (row.id == 80) {
          console.log('跳转企业文化');
          this.$router.push({
            path: 'culture'
          })
        }

        return false;



        this.$router.push({
          path: 'enterprise'
        })
      },

      //获取案例信息
      getCopy() {
        var that = this;
        postconfigAPI().then(function(res) {

          that.copydata = res.data.data.list;
          console.log(that.copydata);

        }).catch(function(err) {
          console.log(err);
        })
      },

    },
    mounted() {
      var that = this;
      console.log('你好世界2');
      /* eslint-disable no-new */
      this.getCopy();



      window.addEventListener('mousewheel', this.handleScroll);

      postIndexAPI({}).then(res => {
        console.log(res);
        that.banner = res.data.data;
        // if (res.data.code == 200) {
        //   that.$message({
        //     message: '设置成功',
        //     type: 'success'
        //   });
        // } else {
        //   that.$message({
        //     message: res.data.msg,
        //     type: 'warning'
        //   });
        // }
        setTimeout(function() {
          mySwiper = new Swiper('.swiper-container', {
            slidesPerView: 3,
            spaceBetween: 0,
            slidesPerGroup: 1,
            speed: 600,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            breakpoints: {
              320: {
                slidesPerView: 1,

              },
              768: {
                slidesPerView: 3,

              }
            },
          })
        }, 200)
      }).catch(err => {
        console.log(err)
      })

    }

  }
</script>

<style lang="less" scoped>
  // 引入公共css3
  @import '../../assets/css3.css';

  template {
    min-height: 100%;
  }

  html,
  body {
    position: relative;
    min-height: 100%;

  }

  .banner {
    overflow-x: hidden;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0px;

    .swiper-container {
      height: 100%;

      .item {
        position: absolute;
        width: 100%;
        height: 100%;

        .text_box {
          color: #fff;
          text-align: left;
          position: absolute;
          bottom: 10%;
          padding: 50px;

          .t1 {
            font-size: 48px;
            font-weight: bold;
            font-family: Arial, Helvetica, sans-serif;
            margin-bottom: 6px;
          }

          .t2 {
            font-size: 38px;
            margin-bottom: 20px;
          }

          .t3 {
            font-size: 22px;
            overflow-x: overlay;
            width: 100%;
            position: relative;

            span {
              position: relative;
              left: -100%;
              opacity: 0;
            }
          }



        }
      }

      .item:hover .t3 span {
        left: 0px;
        opacity: 1;
      }
    }

    .index_prev {
      position: fixed;
      bottom: 5%;
      width: 40px;
      z-index: 999;
      height: 40px;
      border-radius: 50%;

      left: 50px;
      cursor: pointer;
    }

    .index_next {
      position: fixed;
      bottom: 5%;
      width: 40px;
      z-index: 999;
      height: 40px;
      border-radius: 50%;

      right: 50px;
      cursor: pointer;
    }
  }

  .copy_bottom {
    position: fixed;
    left: 0px;
    width: 95%;
    bottom: 10px;
    color: #666;
    font-size: 12px;
    text-align: right;

  }
</style>



// WEBPACK FOOTER //
// src/view/index/index.vue